import { FC } from 'react';
import { Box, DialogContentText } from '@mui/material';
import { Calculate, LocalShipping } from '@mui/icons-material';
import { ProcessingStepsLoader } from 'ui/ProcessingStepsLoader';
import { TProcessingStep } from 'ui/ProcessingStepsLoader/types';

const SHIPMENT_PROCESSING_STEPS: TProcessingStep[] = [
	{ label: 'Calculating Taxes & Duties', icon: <Calculate /> },
	{ label: 'Calculating Shipping Cost', icon: <LocalShipping /> },
];

export const StepInitial: FC = () => {
	return (
		<>
			<DialogContentText>
				We’re calculating your delivery cost. This may take a moment.
			</DialogContentText>
			<Box sx={{ mt: 2 }}>
				<ProcessingStepsLoader steps={SHIPMENT_PROCESSING_STEPS} />
			</Box>
		</>
	);
};
